import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import OrangeBtn from "../../cta/OrangeBtn";

function BannerLeftBox() {
  return (
    <div className="innerLeftWrap">
      <h1>Security Built for Business Growth</h1>
      <p>
        We protect your data, systems, and reputation so your business stays secure and uninterrupted.
      </p>
      <div className="readMoreBtnWrap">
        <OrangeBtn
          redirecLink="###"
          clsName="btn w-45 greenBtn"
          btnName="Get A Consultation"
        />
      </div>
      <ul className="ulLsit">
        <li>
          <span>
            <FontAwesomeIcon icon={faCheckCircle} />
          </span>
          Top-tier security without the complexity
        </li>
        <li>
          <span>
            <FontAwesomeIcon icon={faCheckCircle} />
          </span>
          Real-time threat visibility and action
        </li>
        <li>
          <span>
            <FontAwesomeIcon icon={faCheckCircle} />
          </span>
          Led by experts in cybersecurity and compliance
        </li>
      </ul>
      
    </div>
  );
}

export default BannerLeftBox;
